import { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, Button, Alert } from '@mui/material';
import { Link } from 'react-router-dom';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import loadingGif from '../../Assets/loading.gif';
import Api from '../../Services/Api';
import FastTextField from "../FastTextField";
import FastAutocomplete from "../FastAutocomplete";
import FormikValidation from "../FormikValidation";

function InstallationMove(props) {
	const [loading, setLoading] = useState(false);
	const [displayAlert, setDisplayAlert] = useState(0);

    let { installation, customer } = props;

    const [listCustomers, setListCustomers] = useState([])
    const [listCustomersResponse, setListCustomersResponse] = useState(null)
    const [selectedCustomer, setSelectedCustomer] = useState(null);

	const formik = useFormik({
		initialValues: {
			customer_id: null,
			notes_move: "",
            installation_id: parseInt(installation),
			_method: 'post',    //select /move from /update to the same endpoint
		},
		validationSchema: Yup.object({
			customer_id:
				Yup.number()
				.integer("Valore non accettato")
				.min(-1)
				.max(18446744073709551615, 'Valore non accettato')	//Bigint
				.required('Campo obbligatorio'),
			notes_move:
				Yup.string()
				.min(2, 'Lunghezza minima 2 caratteri')
				.max(50, 'Lunghezza massima 150 caratteri'),
		}),
		onSubmit: values => {
			setLoading(true);

			try {
				let currEndpoint = `installation/${installation}`;
				Api.post({endpoint: currEndpoint, body: values, contentType : 'application/json'})
					.then(response => {
						setDisplayAlert(1);
						//let timer1 = setTimeout(() => {setLoading(false);clearTimeout(timer1)}, 3000);
					})
					.catch(error => {
						if (error.response?.status === 412) {
							if (error.response?.data?.code === 1062) {
								alert("Non è possibile impostare le prossime 'Prova fumi' e 'Manutenzione' in contemporanea");
							}
							setDisplayAlert(0);
							setLoading(false);
							return;
						}
						if (error.response?.status === 422) {
							var errors = JSON.parse(error.request.response);
							if (errors.hasOwnProperty('errors')) {
								var alertMessage = "Si sono verificati errori nei dati:";
								for (var errorField in errors.errors) {
									alertMessage += "\n" + errors.errors[errorField].join(',');
								}
								alert(alertMessage);
								setDisplayAlert(0);
								setLoading(false);
							}
							else {
								console.log(error);
							}
							return;
						}
						else {
							console.log(error);
							alert("Errore inatteso!");
						}
						setDisplayAlert(-1);
					});
			} catch (error) {
				console.log(error);
				setDisplayAlert(-1);
			}
		},
		enableReinitialize: true,
	});

	function confirmGoBack(checkChanged) {
		if (checkChanged && Object.keys(formik.touched).length > 0) {
			if (!window.confirm("Uscire senza salvare le modifiche?")) {
				return false;
			}
		}
		return true;
	}

	function gotoBackCustomer(checkChanged) {
		return (
			<Link to={`/cms/customers/edit/${customer}`} style={{margin: 'auto'}}
				onClick={e => !confirmGoBack(checkChanged) && e.preventDefault()}
			>
				<Button
					variant="outlined"
					sx={{ ml: 3 }}
				>
					Torna al Cliente!
				</Button>
			</Link>
		);
	}

    function gotoBackInstallation(checkChanged) {
		return (
			<Link to={`/cms/installations/edit/${installation}/${selectedCustomer.id}`} style={{margin: 'auto'}}
				onClick={e => !confirmGoBack(checkChanged) && e.preventDefault()}
			>
				<Button
					variant="outlined"
					sx={{ ml: 3 }}
				>
					Torna all'Impianto!
				</Button>
			</Link>
		);
	}

	const customerSelected = (customer) => {
		if (customer?.id) {	//Read FastAutocomplete.handleOnChange notes
			setSelectedCustomer(customer);
		}
		if (customer === null) {
			setSelectedCustomer(null);
		}
	}

	useEffect(() => {
		try {
            Api.get({endpoint: `customer?combo=1`, contentType : 'application/json'})
                .then(response => {
                    setListCustomersResponse(response.data.customers);
                })
                .catch(error => {
                    console.log(error);
                    setListCustomersResponse(null);
                    setDisplayAlert(-1);
                });
		} catch (error) {
			console.log(error);
			return (error.response ? error.response?.status : null);
		}
	}, []);	// eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		try {
			if (!listCustomersResponse) {
				setListCustomers([
					{ id: -1, label: 'Caricamento in corso...' },
				]);
			}
			else {
				setListCustomers(listCustomersResponse);	//Already formatted in controller
			}
		} catch (error) {
			console.log(error);
			return (error.response ? error.response?.status : null);
		}
	}, [listCustomersResponse]);	// eslint-disable-line react-hooks/exhaustive-deps

	return (
		<form
			autoComplete="off"
			noValidate
			onSubmit={formik.handleSubmit}
		>
			<Card>
				<CardHeader
					title="Impianto"
					subheader="Sposta l'Impianto su un altro Cliente mantenendo le manutenzioni passate e future"
				/>
				<CardContent sx={{ pt: 0 }}>
					<div key="r_customer_id" className="row styled">
						<div key="customer_id" className="col-md-6">
                            <FastAutocomplete
                                field="customer_id"
                                formik={formik}
                                options={listCustomers}
                                onChange={customerSelected}
                                loading={loading}
                                label="Cliente"
                                required={true}
                            />
						</div>
					</div>
					<div key="r_notes_move" className="row styled">
                        <div key="notes_move" className="col-md-9">
                            <FastTextField loading={loading} formik={formik} label="Note di spostamento" field="notes_move" />
                        </div>
                    </div>

					<div className="row styled">
						<div className="col">
							{loading && (
									<>
										<>
										{displayAlert === 0 && (
											<img className="pl-3" src={loadingGif} alt="Loading..."/>
										)}
										</>
										<>
										{displayAlert === -1 && (
											<Alert severity="error">Si è verificato un errore imprevisto. Riprovare più tardi</Alert>
										)}
										</>
										<>
										{displayAlert === 1 && (
											<Alert severity="success">
                                                <>Dati salvati con successo!</>
												{gotoBackCustomer()}
												{gotoBackInstallation()}
											</Alert>
										)}
										</>
									</>
							)}
							{!loading && (
								<>
									<Button
										variant="contained"
										type="submit"
									>
                                        Invia dati
									</Button>
                                    {gotoBackCustomer(true)}
								</>
							)}
						</div>
					</div>
					<FormikValidation formikValues={formik.values} formikErrors={formik.errors} formikTouched={formik.touched} />
				</CardContent>
			</Card>
			<FormikValidation formikValues={formik.values} formikErrors={formik.errors} formikTouched={formik.touched} tech={true} />
		</form>
	);

}

export default InstallationMove;